import React, { FC, HTMLAttributes, memo, useMemo, useRef, useState } from "react";
import { offset, UseFloatingOptions } from "@floating-ui/react";
import { Tooltip, TooltipInstance } from "../../Tooltip";

import styles from "./styles.module.scss";

export const Day: FC<HTMLAttributes<HTMLSpanElement>> = memo(({ children }) => {
  const [ isHover, setHover ] = useState(false);
  const ref = useRef<HTMLSpanElement | null>(null);
  const tooltipRef = useRef<TooltipInstance | null>(null);
  const message = ref?.current?.parentElement?.getElementsByClassName("overlay")?.[0]?.textContent ?? "";

  return (
    <>
      <Tooltip
        content={message}
        isOpen={isHover}
        ref={tooltipRef}
        options={useMemo<UseFloatingOptions>(() => ({
          placement: "bottom",
          middleware: [ offset(-5) ],
        }), [])}
      >
        <span />
      </Tooltip>
      <span
        className={styles.span}
        title=""
        ref={ref}
        onPointerEnter={() => {
          setHover(true);
          if (tooltipRef.current?.refs) {
            tooltipRef.current.refs.setPositionReference(ref.current);
            tooltipRef.current.update();
          }
        }}
        onPointerLeave={() => setHover(false)}
      >
        {children}
      </span>
    </>
  );
});